import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Collaboration, Site } from '../../shared/model';
import { DatabaseConnection } from '../../shared/services/database-connection';

@Injectable({
  providedIn: 'root',
})
export class SiteService {

  end_url = 'site'

  constructor(private http : HttpClient, private  dbConnection : DatabaseConnection){}

  getAll(){
    return this.http.get<Site[]>(this.dbConnection.remoteApiConnection.value + this.end_url + '/create')
  }

  get(id : string){
    return this.http.get<Site>(this.dbConnection.remoteApiConnection.value + this.end_url + '/' + id)
  }

  create(data : FormData){
    return this.http.post<Site>(this.dbConnection.remoteApiConnection.value + this.end_url, data)
  }

  update(data : FormData, id : string){
    return this.http.put<Site>(this.dbConnection.remoteApiConnection.value + this.end_url + '/' + id, data)
  }

  delete(id : string){
    return this.http.delete(this.dbConnection.remoteApiConnection.value + this.end_url + '/' + id)
  }

  changeStatus(id : string){
    return this.http.get<Site>(this.dbConnection.remoteApiConnection.value + this.end_url + '/' + id + '/edit')
  }

  getSiteUsers(site_id : string){
    return this.http.get<any[]>(this.dbConnection.remoteApiConnection.value + 'site-user/' + site_id)
  }

  getSiteDocuments(site_id : string){
    return this.http.get<any[]>(this.dbConnection.remoteApiConnection.value + 'site-doc/' + site_id)
  }

  getSiteCollaborateurs(site_id : string){
    return this.http.get<any[]>(this.dbConnection.remoteApiConnection.value + 'site-collab/' + site_id)
  }

  changeCollabState(collab_id : string){
    return this.http.post<Collaboration>(this.dbConnection.remoteApiConnection.value + 'change-collab-state', {id : collab_id})
  }
}
